import { CurrencyDisplayUtil } from './../common/currency-display-util';
import { CHART_COLORS } from './../common/color-util';
import { AmChartsService, AmChart } from '@amcharts/amcharts3-angular';
const RESPONSIVE_CHART_SETTINGS = {
    'enabled': true,
    'rules': [
        {
            'minWidth': 250,
            'maxWidth': 499,
            'overrides': {
                // 'fontSize': 8,
                'labelsEnabled': false,
            }
        },
        {
            'minWidth': 500,
            'maxWidth': 699,
            'overrides': {
                // 'fontSize': 10,
                'labelsEnabled': false,
            }
        },
        {
            'minWidth': 700,
            'maxWidth': 899,
            'overrides': {
                // 'fontSize': 12,
            }
        },
        {
            'minWidth': 900,
            'overrides': {
                // 'fontSize': 14,
            }
        }
    ],
};


export function createXYChart(amChartsService: AmChartsService,
    divId: string,
    dataProvider: any[],
    titleField: string,
    valueField: string): AmChart {
    return amChartsService.makeChart(divId, {
        'type': 'xy',
        'hideCredits': true,
        'theme': 'light',
        'colors': CHART_COLORS,
        'autoMarginOffset': 20,
        'dataProvider': dataProvider,
        'usePrefixes': true,
        'valueAxes': [{
            'position': 'bottom',
            'axisAlpha': 0,
            'dashLength': 1,
            'type': 'date',
            'minPeriod': 'mm',
            'title': titleField,
        }, {
            'axisAlpha': 0,
            'dashLength': 1,
            'position': 'left',

            'title': valueField,
        }],
        'startDuration': 1,
        'graphs': [
            {
                'balloonText': 'x:[[x]] y:[[y]]',
                'bullet': 'diamond',
                'bulletSize': 12,
                'lineAlpha': 0,
                'xField': titleField,
                'yField': valueField,
                // 'lineColor': '#FF6600',
                'fillAlphas': 0,
            },
        ],
        'trendLines': [{
            'finalValue': 11,
            'finalXValue': 12,
            'initialValue': 2,
            'initialXValue': 1,
            'lineColor': '#FF6600'
        }
        ],
        'marginLeft': 64,
        'marginBottom': 60,
        // 'chartScrollbar': {},
        'chartCursor': {},
        'responsive': RESPONSIVE_CHART_SETTINGS,
        'export': {
            'enabled': true,
            'position': 'bottom-right'
        },
    }
    );
}

export function createPieChart(amChartsService: AmChartsService,
    divId: string,
    dataProvider: any[],
    titleField: string,
    valueField: string): AmChart {
    return amChartsService.makeChart(divId, {
        'type': 'pie',
        'hideCredits': true,
        'startDuration': 0,
        'theme': 'light',
        'colors': CHART_COLORS,
        // 'startEffect': 'easeOutSine',
        // 'pullOutEffect': 'elastic',
        'pullOutOnlyOne': true,
        'addClassNames': true,
        'classNamePrefix': 'risk',
        'classNameField': 'CompactSource',
        'labelsEnabled': true,
        // 'labelRadius': 50,
        // 'innerRadius': 80,
        'usePrefixes': true,
        'outlineAlpha': 0.4,
        'depth3D': 25,
        // 'balloonText': '[[title]]<br><span style=\'font-size:14px\'><b>[[value]]</b> ([[percents]]%)</span>',
        'balloonFunction': overridePieBalloonFunction,
        'angle': 30,
        'groupPercent': 5,
        'groupedTitle': 'Other',

        'legend': {
            'position': 'right',
            // 'marginRight': 10,
            'autoMargins': true,
            // 'marginTop': 0,
            'switchable': false,
            'markerType': 'circle',
            'valueFunction': overrideLegendValueFunction,
            // 'marginBottom': 40,
            // 'marginLeft': 40,
            // 'valueFunction': (item) => {
            //     return item.dataContext['percents'] + '% (' + item.dataContext['RawAmount'] + ')';
            // },
            // 'labelText': '',
            // 'valueText': '[[percents]]% ([[RawAmount]])',
            // 'maxColumns': 2,
            // 'divId': 'risklegenddiv',
            'markerLabelGap': 40
        },
        // 'innerRadius': '30%',
        // 'defs': {
        //     'filter': [{
        //         'id': 'shadow',
        //         'width': '200%',
        //         'height': '200%',
        //         'feOffset': {
        //             'result': 'offOut',
        //             'in': 'SourceAlpha',
        //             'dx': 0,
        //             'dy': 0
        //         },
        //         'feGaussianBlur': {
        //             'result': 'blurOut',
        //             'in': 'offOut',
        //             'stdDeviation': 5
        //         },
        //         'feBlend': {
        //             'in': 'SourceGraphic',
        //             'in2': 'blurOut',
        //             'mode': 'normal'
        //         }
        //     }]
        // },
        'dataProvider': dataProvider,
        'valueField': valueField,
        'titleField': titleField,
        // 'labelText': '[[CompactSource]] [[percents]]% ([[RawAmount]])',
        'showZeroSlices': false,
        'precision': 2,
        'autoMargins': true,
        'marginTop': 20,
        'marginBottom': 20,
        'marginLeft': 20,
        'marginRight': 20,
        'pullOutRadius': 10,
        'responsive': RESPONSIVE_CHART_SETTINGS,
        // 'export': {
        //     'enabled': true,
        //     'position': 'bottom-right'
        // },
        'listeners': [
            {
                'event': 'pullOutSlice',
                'method': (event) => {
                    // if (event.dataItem.dataContext['Source'] !== undefined) {
                    //     const pieWedgeColor = event.dataItem.color || '';
                    //     this.explainTablesComponent.headerColor = pieWedgeColor;
                    //     this.explainTablesComponent.selectedDataType = event.dataItem.dataContext['Source'];
                    // } else {
                    //     this.explainTablesComponent.show(this.liquidityMode, 'top');
                    // }
                }
            },
            {
                'event': 'pullInSlice',
                'method': (event) => {
                    // this.explainTablesComponent.headerColor = '';
                    // this.explainTablesComponent.show(this.liquidityMode, 'top');
                }

            },
            {
                'event': 'rollOverSlice',
                'method': (event) => {
                    const wedge = event.dataItem.wedge.node;
                    wedge.parentNode.appendChild(wedge);
                }
            }
        ],
    });
}

export function createSerialChart(amChartsService: AmChartsService,
    divId: string,
    graphType: string,
    isTimeBased: boolean,
    isStacked: boolean,
    dataProvider: any[],
    xField: string,
    yFields: string[],
    deltaField?: string): AmChart {

    let fillAlpha, lineThickness, startOnAxis, equalSpacing;
    switch (graphType) {
        case 'line':
            fillAlpha = 0;
            lineThickness = 3;
            break;
        case 'column':
            fillAlpha = 0.7;
            lineThickness = 1;
            startOnAxis = true;
            equalSpacing = true;
            break;
    }
    const graphs = yFields.map((yField: string, index: number) => {
        const graph = {
            'id': 'g' + index,
            'type': graphType,
            'title': yField,
            'fillAlphas': fillAlpha,
            'lineThickness': lineThickness,
            'valueField': yField,
            'valueAxis': 'main',
            'balloonFunction': overrideBalloonFunction,
        };
        return graph;
    });
    const valueAxes = [];
    const mainValueAxis = {
        'id': 'main',
        'position': 'left',
        'labelText': '',
        'labelFunction': overrideLabelFunction,
    }
    if (isStacked) {
        mainValueAxis['stackType'] = 'regular';
    }
    valueAxes.push(mainValueAxis)
    if (deltaField) {
        const deltaGraph = {
            'id': 'delta',
            'type': 'column',
            'title': 'Delta',
            'fillAlphas': 0.4,
            'lineThickness': 1,
            'valueField': deltaField,
            'valueAxis': 'delta',
            'balloonFunction': overrideBalloonFunction,
        };
        graphs.push(deltaGraph);
        const deltaAxis = {
            'id': 'delta',
            'position': 'right',
            'title': deltaField
        };
        valueAxes.push(deltaAxis);
    }
    let categoryAxis;
    if (isTimeBased) {
        categoryAxis = {
            'minPeriod': 'mm',
            'type': 'date',
            'parseDates': true
        };
    } else {
        categoryAxis = {};
    }
    if (graphType === 'column') {
        categoryAxis['equalSpacing'] = equalSpacing;
    }
    let legend;
    if (yFields.length > 1) {
        legend = {
            'position': 'right',
            'autoMargins': true,
            'switchable': false,
            'markerType': 'circle',
            'markerLabelGap': 40
        };
    }

    return amChartsService.makeChart(divId, {
        'type': 'serial',
        'hideCredits': true,
        'theme': 'light',
        'marginRight': 80,
        'autoMargins': true,
        'dataProvider': dataProvider,
        'usePrefixes': true,
        'valueAxes': valueAxes,
        'graphs': graphs,
        // 'chartScrollbar': {
        //     'graph': 'g1',
        //     'scrollbarHeight': 80,
        //     'backgroundAlpha': 0,
        //     'selectedBackgroundAlpha': 0.1,
        //     'selectedBackgroundColor': '#888888',
        //     'graphFillAlpha': 0,
        //     'graphLineAlpha': 0.5,
        //     'selectedGraphFillAlpha': 0,
        //     'selectedGraphLineAlpha': 1,
        //     'autoGridCount': true,
        //     'color': '#AAAAAA'
        // },
        'chartCursor': {
            'categoryBalloonDateFormat': 'JJ:NN, DD MMMM',
            'cursorPosition': 'mouse'
        },
        'categoryField': xField,
        'categoryAxis': categoryAxis,
        'colors': CHART_COLORS,
        'legend': legend,
        'responsive': RESPONSIVE_CHART_SETTINGS,
        'export': {
            'enabled': true,
            'position': 'bottom-right'
        },
    }
    );
}

function overrideLabelFunction(value, valueText, valueAxis): string {
    return CurrencyDisplayUtil.toShortNumber(value, 0);
}

function overrideBalloonFunction(graphDataItem, graph): string {
    return CurrencyDisplayUtil.toShortNumber(graphDataItem.values.value);
}

function overridePieBalloonFunction(graphDataItem, graph): string {
    const value = CurrencyDisplayUtil.toShortNumber(graphDataItem.value);
    return `${graphDataItem.title}<br><span style=\'font-size:14px\'><b>${value}</b> (${graphDataItem.percents.toFixed(2)}%)</span>`;
}
function overrideLegendValueFunction(dataContext: any): string {
    return CurrencyDisplayUtil.toShortNumber(dataContext.value, 2);
}
